import {AddressBaseValidation} from "@/classes/global/AddressBaseValidation";
import Validation from "@/classes/global/Validation";

export class PickStockValidation extends AddressBaseValidation {

    constructor() {

        super();

        this.customerRef = new Validation();
        this.releaseDate = new Validation();
        this.releaseTime = new Validation();
        this.deliveryDate = new Validation();
        this.action = new Validation();
        this.deliveryInstructions = new Validation();
        this.phone = new Validation();
        this.email = new Validation();
        this.value = new Validation();
    }
}